import React from 'react';
import './App.css';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';

import SidePanel from '././Dashboard/SidePanel';
import MessagesArea from '././Chat Section/MessagesArea';
import AboutPanel from './About Section/AboutPanel';

const App = ({ currentUser, currentChannel, isPrivateChannel }) => (

  <Grid columns='equal' className='main' style={{ background: '#4c4c4c' }}>
    <SidePanel
      key={ currentUser && currentUser.uid }
      currentUser = {currentUser}
    />
    
    <Grid.Column style={{ marginLeft: 270 }}>
      <MessagesArea
        key = {currentChannel && currentChannel.id}
        currentChannel = {currentChannel}
        currentUser = {currentUser}
        isPrivateChannel={isPrivateChannel}
      />
    </Grid.Column>

    <Grid.Column width={3}>
      <AboutPanel 
        key={ currentChannel && currentChannel.id }
        currentChannel = {currentChannel}
        currentUser = {currentUser}
        isPrivateChannel={isPrivateChannel}
      />
    </Grid.Column>
  </Grid>

);

const mapStateToProps = state => ({
  currentUser: state.user.currentUser, 
  currentChannel: state.channel.currentChannel, 
  isPrivateChannel: state.channel.isPrivateChannel
});

export default connect(mapStateToProps)(App);
